// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"horizontal-scroll_scrollWrapper__hQ7DI","scroll":"horizontal-scroll_scroll__QZNIy"};